import instance from "../utils/network";
import { FranchiseResponse } from "./cafe";

export enum EventAttendeeType {
  YOUTUBER = "YOUTUBER",
  AMBASSADOR = "AMBASSADOR",
}

export interface EventScheduleDto {
  id: number;
  date: string;
  title: string;
  pubId: number;
  pubName: string;
  attendeeId: number;
  attendeeName: string;
  attendeeImageUrl: string;
  attendeeType: EventAttendeeType;
  ord: number;
  link: string;
}

export interface EventScheduleResponse {
  date: string;
  list: EventScheduleDto[];
}

export interface EventScheduleAttendeeRespone {
  id: number;
  type: EventAttendeeType;
  name: string;
  imageUrl: string;
}
export interface EventScheduleCountResponse {
  date: string;
  count: number;
}

export function getEventScheduleByDate(
  date: string,
  pubId?: number,
  attendeeId?: number
): Promise<EventScheduleResponse[]> {
  if (pubId !== -1 && attendeeId !== -1) {
    return instance.get(
      `/nest/event-schedule/date?date=${date}&pubId=${pubId}&attendeeId=${attendeeId}`
    );
  } else if (pubId !== -1) {
    return instance.get(
      `/nest/event-schedule/date?date=${date}&pubId=${pubId}`
    );
  } else if (attendeeId !== -1) {
    return instance.get(
      `/nest/event-schedule/date?date=${date}&attendeeId=${attendeeId}`
    );
  }
  return instance.get(`/nest/event-schedule/date?date=${date}`);
}

export function getEventScheduleByMonth(
  year: number,
  month: number,
  pubId?: number,
  attendeeId?: number
): Promise<EventScheduleResponse[]> {
  if (pubId !== -1 && attendeeId !== -1) {
    return instance.get(
      `/nest/event-schedule/month?year=${year}&month=${month}&pubId=${pubId}&attendeeId=${attendeeId}`
    );
  } else if (pubId !== -1) {
    return instance.get(
      `/nest/event-schedule/month?year=${year}&month=${month}&pubId=${pubId}`
    );
  } else if (attendeeId !== -1) {
    return instance.get(
      `/nest/event-schedule/month?year=${year}&month=${month}&attendeeId=${attendeeId}`
    );
  }
  return instance.get(`/nest/event-schedule/month?year=${year}&month=${month}`);
}

export function getEventScheduleCount(
  year: number,
  month: number,
  pubId?: number,
  attendeeId?: number
): Promise<EventScheduleCountResponse[]> {
  if (pubId !== -1 && attendeeId !== -1) {
    return instance.get(
      `/nest/event-schedule/count?year=${year}&month=${month}&pubId=${pubId}&attendeeId=${attendeeId}`
    );
  } else if (pubId !== -1) {
    return instance.get(
      `/nest/event-schedule/count?year=${year}&month=${month}&pubId=${pubId}`
    );
  } else if (attendeeId !== -1) {
    return instance.get(
      `/nest/event-schedule/count?year=${year}&month=${month}&attendeeId=${attendeeId}`
    );
  }
  return instance.get(`/nest/event-schedule/count?year=${year}&month=${month}`);
}

export function getEventScheduleAttendee(
  year: number,
  month: number
): Promise<EventScheduleAttendeeRespone[]> {
  return instance.get(
    `/nest/event-schedule/attendee?year=${year}&month=${month}`
  );
}

export function getEventSchedulePub(
  year: number,
  month: number
): Promise<FranchiseResponse[]> {
  return instance.get(`/nest/event-schedule/pub?year=${year}&month=${month}`);
}
